import React from 'react';
import { useQuery } from 'react-query';
import Meet from './Meet/Meet';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import { main_color_50 } from '../../../styles/_variables';
import { useUserStore } from '../../../store/useUser';

import styles from './UserMeets.module.scss';
import { getUserMeets } from '../../../service/meet';
import Filter, { FilterItem } from '../../../components/Filter/CustomFilter';
import useSearchParam from '../../../hooks/useQueryParams';
import { Divider, Spin } from 'antd';

import useHeader from '../../../hooks/useHeader';

const UserMeets = () => {
  const [searchState, setSearchState] = useSearchParam<string>('date')

  const userId = useUserStore(state => state.id)

  const { data:meets, isFetching } = useQuery(
    ['meets', searchState, 'user', userId],
    () => getUserMeets(userId, searchState),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: 'Seus Encontros' });

  if(!searchState) setSearchState('waiting')

  return (
    <section>
      <HeaderPage header="Meus Encontros" bageColor={main_color_50}/>
      <Filter>
        <FilterItem 
          onClick={e => setSearchState('waiting')} 
          active={searchState === 'waiting'}>
            Aguardando
        </FilterItem>
        <FilterItem 
          onClick={e => setSearchState('today')} 
          active={searchState === 'today'}>
            Hoje
        </FilterItem>
        <FilterItem 
          onClick={e => setSearchState('finish')} 
          active={searchState === 'finish'}>
            Finalizado
        </FilterItem>
      </Filter>
      <br/>
      <div className={styles.meets}>
        <Spin spinning={isFetching}>
        <ul className={styles.list}>
          {meets?.map(meet =>
            <li key={`meet-${meet?.id}`}>
              <Meet
                meet={meet}
                key={`meet-${meet?.id}`}
              />
              <Divider />
            </li> 
          )}
        </ul>
        </Spin>
      </div>
    </section>
  )
}

export default UserMeets;